'use client';
import type { EmitEventType } from '@unifyapps/defs/hooks/useBlockEvents';
import { ApplicationType } from '@unifyapps/defs/types/interface';
import { PrintProvider } from '../../../../context/PrintContext';
import { dynamic } from '../../../../external/dynamic';
import { useInterfaceStore } from '../../../stores/InterfaceStore';
import { InterfacePage } from '../InterfacePage';
import { InterfacePagePrintLayout } from '../InterfacePagePrintLayout';
import { useIntegrationsVisibility } from './hooks/useIntegrationsVisibility';

const CopilotChatInterface = dynamic(() =>
  import(
    /* webpackChunkName: "CopilotChatInterface" */
    '../../CopilotChatInterface'
  ).then((mod) => mod.CopilotChatInterface),
);

const CopilotChatInterfaceWithLauncher = dynamic(() =>
  import(
    /* webpackChunkName: "CopilotChatInterfaceWithLauncher" */
    '../../CopilotChatInterface/CopilotChatInterfaceWithLauncher'
  ).then((mod) => mod.CopilotChatInterfaceWithLauncher),
);

export function InterfacePageWithCopilotChat(props: {
  className?: string;
  workspaceClassName?: string;
  colorScheme?: string;
  onClose?: () => void;
  onLoad?: () => void;
  eventEmitterRef?: React.RefObject<{ emitEvent: EmitEventType } | null>;
  onPageEvent?: EmitEventType;
}) {
  const interfaceRecord = useInterfaceStore().hooks.record.useDetails();

  if (interfaceRecord.properties.manifest?.type === ApplicationType.COPILOT) {
    return (
      <CopilotChatInterface
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- will be present
        eventEmitterRef={props.eventEmitterRef!}
        onClose={props.onClose}
        onLoad={props.onLoad}
        onPageEvent={props.onPageEvent}
      />
    );
  }

  return (
    <InterfacePagePrintLayout>
      <InterfacePage {...props} />
    </InterfacePagePrintLayout>
  );
}

export function InterfacePageWithCopilotChatLauncher(props: {
  className?: string;
  workspaceClassName?: string;
  colorScheme?: string;
  searchParams?: Record<string, string>;
}) {
  const interfaceRecord = useInterfaceStore().hooks.record.useDetails();

  useIntegrationsVisibility();

  if (interfaceRecord.properties.manifest?.type === ApplicationType.COPILOT) {
    return <CopilotChatInterfaceWithLauncher />;
  }

  return (
    <PrintProvider searchParams={props.searchParams}>
      <InterfacePagePrintLayout>
        <InterfacePage {...props} />
      </InterfacePagePrintLayout>
    </PrintProvider>
  );
}
